import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogActions, Button, IconButton } from '@mui/material';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';


import { styled } from '@mui/system';


const StyledDialogActions = styled(DialogActions)({
  display: 'flex',
  justifyContent: 'center',
});

const DialogContainer = styled(Dialog)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: '100vh',
  justifyContent: 'center' // Center the dialog vertically
});

const DialogContentStyled = styled(DialogContent)({
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  height: '100vh',
});

const Image = styled('img')({
  display: 'flex',
  height: '100%',
});

const ImageDialog = ({ open, handleClose, imageUrl }) => {
  const [dragging, setDragging] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });
  const [zoomLevel, setZoomLevel] = useState(1);

  useEffect(() => {
    if (!open) {
      setPosition({ x: 0, y: 0 });
      setZoomLevel(1);
    }
  }, [open]);

  const handleMouseDown = (event) => {
    setDragging(true);
    setStartPosition({
      x: event.clientX - position.x * zoomLevel,
      y: event.clientY - position.y * zoomLevel,
    });
  };

  const handleMouseMove = (event) => {
    if (dragging) {
      const newPosition = {
        x: (event.clientX - startPosition.x) / zoomLevel,
        y: (event.clientY - startPosition.y) / zoomLevel,
      };
      setPosition(newPosition);
    }
  };

  const handleMouseUp = () => {
    setDragging(false);
  };

  const handleZoomIn = () => {
    setZoomLevel(zoomLevel + 0.1);
  };

  const handleZoomOut = () => {
    const newZoomLevel = Math.max(1, zoomLevel - 0.1);
    setZoomLevel(newZoomLevel);
  };

  const handleWheel = (event) => {
    event.preventDefault();
    const deltaY = event.deltaY;
    if (deltaY < 0) {
      handleZoomIn();
    } else {
      handleZoomOut();
    }
  };

  return (
    <DialogContainer open={open} onClose={handleClose} maxWidth="xl" fullWidth>
      <DialogContentStyled
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onWheel={handleWheel}
      >
        <Image
          src={imageUrl}
          draggable="false"
          style={{
            scrollbarColor: 'transparent',
            cursor: dragging ? 'grabbing' : 'grab',
            userSelect: 'none',
            transform: `scale(${zoomLevel}) translate(${position.x}px, ${position.y}px)`,
          }}
        />
      </DialogContentStyled>
      <StyledDialogActions>
        <IconButton onClick={handleZoomIn}>
          <ZoomInIcon fontSize="large" style={{color: "#2E2E2E"}} />
        </IconButton>
        <IconButton onClick={handleZoomOut}>
          <ZoomOutIcon fontSize="large" style={{color: "#2E2E2E"}} />
        </IconButton>
      </StyledDialogActions>
    </DialogContainer>
  );
};

export default ImageDialog;